import axiosInstance from '../axiosInstance';

const getById = async (id) => {
  try {
    const response = await axiosInstance.get(`/bracket/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const getByEventId = async (eventId) => {
  try {
    const response = await axiosInstance.get(`/bracket/event/${eventId}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const update = async (id, data) => {
  try {
    await axiosInstance.put(`/bracket/${id}`, data);
    return true;
  } catch (error) {
    console.error(error);
  }
};

const generate = async (data) => {
  try {
    const response = await axiosInstance.post(`/bracket/generate/${data.eventId}`, data);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const remove = async (id) => {
  try {
    await axiosInstance.delete(`/bracket/${id}`);
    return true;
  } catch (error) {
    console.error(error);
  }
};

const changeTeam = async (bracketId, matchId, teamId, newTeam) => {
  try {
    const response = await axiosInstance.put(`/bracket/${bracketId}/match/${matchId}/teamUpdate`, {
      teamId,
      newTeam
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const updateTeamStatus = async (bracketId, matchId, teamId, status) => {
  try {
    const response = await axiosInstance.put(`/bracket/${bracketId}/match/${matchId}/teamStatus`, {
      teamId,
      status
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const removeTeam = async (bracketId, matchId, teamId) => {
  try {
    const response = await axiosInstance.delete(
      `/bracket/${bracketId}/match/${matchId}/team/${teamId}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const bracketService = {
  getById,
  getByEventId,
  update,
  generate,
  remove,
  changeTeam,
  updateTeamStatus,
  removeTeam
};

export default bracketService;
